module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-01-a8424fda47337648020bbba62530c837.jpg";